import React, { useCallback, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import SearchInput from 'components/SearchInput';
import styles from './HelpSearch.module.scss';

// useHelpSearch contains the core UI/UX used for the different app searches
export default function useHelpSearch({
  onChange,
  onClear: onClearProp,
  ...otherProps
} = {}) {
  const intl = useIntl();
  const [query, setQuery] = useState('');
  const inputRef = useRef();

  const onClear = useCallback(() => {
    setQuery('');
    inputRef.current?.focus();
    onClearProp?.();
  }, [inputRef, onClearProp, setQuery]);

  const onInputChange = useCallback(
    e => {
      const newQuery = e.target.value;
      setQuery(newQuery);
      onChange?.(newQuery);
    },
    [onChange, setQuery],
  );

  const searchComponent = (
    <div className={styles.searchWrap}>
      <SearchInput
        className={styles.searchInput}
        data-testid="HelpView_search_input"
        value={query}
        onChange={onInputChange}
        onClear={onClear}
        inputRef={inputRef}
        placeholder={intl.formatMessage({ id: 'HELP_MENU_SEARCH_PLACEHOLDER' })}
        {...otherProps}
      />
    </div>
  );

  return { searchComponent, inputRef, onClear, query, setQuery };
}
